import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeCardElementOptions } from '@stripe/stripe-js';
import { config } from '../config';

// Initialize Stripe
const stripePromise = loadStripe(config.stripe.publishableKey);

const stripeOptions = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap',
      family: 'Inter',
    },
  ],
};

export interface WithStripeElementsOptions {
  stripeOptions?: StripeCardElementOptions;
}

export function withStripeElements<P extends object>(
  Component: React.ComponentType<P>,
  options: WithStripeElementsOptions = {}
) {
  const WrappedComponent = React.forwardRef<any, P>((props, ref) => {
    return (
      <Elements
        stripe={stripePromise}
        options={{ ...stripeOptions, ...options.stripeOptions }}
      >
        <Component {...(props as P)} ref={ref} />
      </Elements>
    );
  });

  WrappedComponent.displayName = `withStripeElements(${Component.displayName || Component.name})`;

  return WrappedComponent;
}

// Export the Stripe promise and options for direct use if needed
export { stripePromise, stripeOptions };
